import * as React from 'react';
import ProgressLoader from '../../components/ProgressLoader/ProgressLoader';
import { ReactChild } from 'react';
import { IStore } from '../../../redux/initialState';
import { connect, ConnectedProps } from 'react-redux';
import { Environment } from '../../../const/environment';
import { ReactChildrenGeneralType } from '../../../models/ReactChildrenGeneralType';

type MainHeaderProps = PropsFromRedux & {
    children: ReactChildrenGeneralType,
    environment?: Environment,
    className?: string,
}

function MainHeader({ children, environment, className, isProjectOptionsSaving }: MainHeaderProps) {
    return <div className={`${environment}`}>
        <div className={`main-header ${className}`}>
            {children}
            {isProjectOptionsSaving && <ProgressLoader style={{ height: '6px' }} position="bottom" />}
        </div>
    </div>;
}

function mapStateToProps({ projectsInfo }: IStore) {
    return {
        isProjectOptionsSaving: projectsInfo.isProjectOptionsSaving,
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(MainHeader);
